import { findADate } from './helpers/index.tsx';

export const getDatePickerFieldValue = (defaultValue: unknown) => {
	if (
		Array.isArray(defaultValue) &&
		defaultValue.length > 0 &&
		typeof defaultValue[0] === 'string'
	) {
		if (findADate(defaultValue[0])) return findADate(defaultValue[0])?.slice(0, 10);
	}
	if (findADate(defaultValue)) return findADate(defaultValue)?.slice(0, 10);
	return null;
};

export const getDateTimePickerFieldValue = (defaultValue: unknown) => {
	if (
		Array.isArray(defaultValue) &&
		defaultValue.length > 0 &&
		typeof defaultValue[0] === 'string'
	) {
		if (findADate(defaultValue[0])) return findADate(defaultValue[0]);
	}
	return findADate(defaultValue);
};
